/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable react/no-unescaped-entities */
import React from 'react'
// import { FaPlus } from 'react-icons/fa'
// import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import Breadcrumb from '../components/Breadcrumb'
import FooterFour from '../components/Footer'
import Navbar from '../components/Navbar'

const PrivacyPolicy = () => {
  const { t } = useTranslation()

  // const industries = t('about-us-industries', { returnObjects: true })

  return (
    <React.Fragment>
      <Navbar />
      <Breadcrumb title="privacy-policy" />
      <div className="container terms">
        <br />
        <p>{t('introduction')}</p>
        <p className="align-self-center">
          {t('usage-note')}
          <a
            href="https://www.termsfeed.com/privacy-policy-generator/"
            target="_blank"
            className="mx-2"
          >
            Privacy Policy Generator
          </a>
          .
        </p>
        <h2>{t('interpretation-and-definitions')}</h2>
        <h3>{t('interpretation')}</h3>
        <p className="align-self-center">{t('interpretation-description')}</p>
        <h3>{t('definitions')}</h3>
        <p>For the purposes of this Privacy Policy:</p>
        <ul>
          <li>
            <p dangerouslySetInnerHTML={{ __html: t('account') }}></p>
          </li>
          <li>
            <p dangerouslySetInnerHTML={{ __html: t('affiliate') }}></p>
          </li>
          <li>
            <p dangerouslySetInnerHTML={{ __html: t('company') }}></p>
          </li>
          <li>
            <p dangerouslySetInnerHTML={{ __html: t('cookies') }}></p>
          </li>
          <li>
            <p dangerouslySetInnerHTML={{ __html: t('country') }}></p>
          </li>
          <li>
            <p dangerouslySetInnerHTML={{ __html: t('device') }}></p>
          </li>
          <li>
            <p dangerouslySetInnerHTML={{ __html: t('personal-data') }}></p>
          </li>
          <li>
            <p
              dangerouslySetInnerHTML={{ __html: t('privacy-policy-service') }}
            ></p>
          </li>
          <li>
            <p dangerouslySetInnerHTML={{ __html: t('service-provider') }}></p>
          </li>
          <li>
            <p dangerouslySetInnerHTML={{ __html: t('usage-data') }}></p>
          </li>
          <li>
            <p dangerouslySetInnerHTML={{ __html: t('website') }}></p>
          </li>
          <li>
            <p dangerouslySetInnerHTML={{ __html: t('you') }}></p>
          </li>
        </ul>
        <h2>{t('collecting-and-using-personal-data')}</h2>
        <h3>{t('types-of-data-collected')}</h3>
        <h4>{t('personal-data-title')}</h4>
        <p>{t('personal-data-collected')}</p>
        <ul>
          <li>{t('usage-data-title')}</li>
        </ul>
        <h4>{t('usage-data-title')}</h4>
        <p>{t('usage-data-collected')}</p>
        <p>{t('usage-data-description')}</p>
        <p>{t('mobile-usage-data')}</p>
        <p>{t('browser-data')}</p>
        <h4>{t('tracking-and-cookies')}</h4>
        <p>{t('tracking-and-cookies-description')}</p>
        <ul>
          <li
            dangerouslySetInnerHTML={{ __html: t('cookies-description') }}
          ></li>
          <li dangerouslySetInnerHTML={{ __html: t('web-beacons') }}></li>
        </ul>
        <p>
          {t('cookies-persistent-or-session')}
          <a href="https://allaboutcookies.org" target="_blank">
            this website
          </a>
        </p>
        <p>{t('cookies-types')}</p>
        <ul>
          <li>
            <p dangerouslySetInnerHTML={{ __html: t('essential-cookies') }}></p>
            <p>{t('essential-cookies-type')}</p>
            <p>{t('essential-cookies-admin')}</p>
            <p>{t('essential-cookies-purpose')}</p>
          </li>
          <li>
            <p
              dangerouslySetInnerHTML={{ __html: t('acceptance-cookies') }}
            ></p>
            <p>{t('acceptance-cookies-type')}</p>
            <p>{t('acceptance-cookies-admin')}</p>
            <p>{t('acceptance-cookies-purpose')}</p>
          </li>
          <li>
            <p>
              <strong>{t('functionality-cookies')}</strong>
            </p>
            <p>{t('functionality-cookies-type')}</p>
            <p>{t('functionality-cookies-admin')}</p>
            <p>{t('functionality-cookies-purpose')}</p>
          </li>
        </ul>
        <p>{t('cookies-info')}</p>
        <h3>{t('use-of-personal-data')}</h3>
        <p>{t('use-of-personal-data-description')}</p>
        <ul>
          <li>
            <p
              dangerouslySetInnerHTML={{
                __html: t('provide-and-maintain-service'),
              }}
            ></p>
          </li>
          <li>
            <p
              dangerouslySetInnerHTML={{
                __html: t('manage-account'),
              }}
            ></p>
          </li>
          <li>
            <p
              dangerouslySetInnerHTML={{
                __html: t('performance-of-contract'),
              }}
            ></p>
          </li>
          <li>
            <p
              dangerouslySetInnerHTML={{
                __html: t('contact-you'),
              }}
            ></p>
          </li>
          <li>
            <p
              dangerouslySetInnerHTML={{
                __html: t('provide-news-offers'),
              }}
            ></p>
          </li>
          <li>
            <p
              dangerouslySetInnerHTML={{
                __html: t('manage-requests'),
              }}
            ></p>
          </li>
          <li>
            <p
              dangerouslySetInnerHTML={{
                __html: t('business-transfers'),
              }}
            ></p>
          </li>
          <li>
            <p
              dangerouslySetInnerHTML={{
                __html: t('other-purposes'),
              }}
            ></p>
          </li>
        </ul>
        <p>{t('sharing-personal-info')}</p>
        <ul>
          <li
            dangerouslySetInnerHTML={{
              __html: t('with-service-providers'),
            }}
          ></li>
          <li
            dangerouslySetInnerHTML={{
              __html: t('business-transfers-info'),
            }}
          ></li>
          <li
            dangerouslySetInnerHTML={{
              __html: t('affiliates-info'),
            }}
          ></li>
          <li
            dangerouslySetInnerHTML={{
              __html: t('business-partners'),
            }}
          ></li>
          <li
            dangerouslySetInnerHTML={{
              __html: t('other-users'),
            }}
          ></li>
          <li
            dangerouslySetInnerHTML={{
              __html: t('other-purposes-info'),
            }}
          ></li>
        </ul>
        <h3>{t('retentionOfYourPersonalData_title')}</h3>
        <p>{t('retentionOfYourPersonalData_paragraph1')}</p>
        <p>{t('retentionOfYourPersonalData_paragraph2')}</p>
        <h3>{t('transferOfYourPersonalData_title')}</h3>
        <p>{t('transferOfYourPersonalData_paragraph1')}</p>
        <p>{t('transferOfYourPersonalData_paragraph2')}</p>
        <p>{t('transferOfYourPersonalData_paragraph3')}</p>

        <h3>{t('deleteYourPersonalData_title')}</h3>
        <p>{t('deleteYourPersonalData_paragraph1')}</p>
        <p>{t('deleteYourPersonalData_paragraph2')}</p>
        <p>{t('deleteYourPersonalData_paragraph3')}</p>
        <p>{t('deleteYourPersonalData_paragraph4')}</p>

        <h3>{t('disclosureOfYourPersonalData_title')}</h3>
        <h4>{t('disclosureOfYourPersonalData_businessTransactions_title')}</h4>
        <p>
          {t('disclosureOfYourPersonalData_businessTransactions_paragraph')}
        </p>
        <h4>{t('law-enforcement')}</h4>
        <p>{t('disclosureOfYourPersonalData_lawEnforcement_paragraph')}</p>
        <h4>
          {t('disclosureOfYourPersonalData_otherLegalRequirements_title')}
        </h4>
        <p>
          {t('disclosureOfYourPersonalData_otherLegalRequirements_paragraph')}
        </p>
        <ul>
          <li>
            {t('disclosureOfYourPersonalData_otherLegalRequirements_listItem1')}
          </li>
          <li>
            {t('disclosureOfYourPersonalData_otherLegalRequirements_listItem2')}
          </li>
          <li>
            {t('disclosureOfYourPersonalData_otherLegalRequirements_listItem3')}
          </li>
          <li>
            {t('disclosureOfYourPersonalData_otherLegalRequirements_listItem4')}
          </li>
          <li>
            {t('disclosureOfYourPersonalData_otherLegalRequirements_listItem5')}
          </li>
        </ul>
        <h3>{t('securityOfYourPersonalData_title')}</h3>
        <p>{t('securityOfYourPersonalData_paragraph')}</p>
        <h2>{t('childrensPrivacy_title')}</h2>
        <p>{t('childrensPrivacy_paragraph1')}</p>
        <p>{t('childrensPrivacy_paragraph2')}</p>
        <h2>{t('linksToOtherWebsites_title')}</h2>
        <p>{t('linksToOtherWebsites_paragraph1')}</p>
        <p>{t('linksToOtherWebsites_paragraph2')}</p>
        <h2>{t('changesToThistitle')}</h2>
        <p>{t('changesToThisparagraph1')}</p>
        <p>{t('changesToThisparagraph2')}</p>
        <p>{t('changesToThisparagraph3')}</p>

        <h2>{t('contactus')}</h2>
        <p>{t('contactUs_paragraph')}</p>
        <ul className="align-self-center terms-email">
          <li>
            By email:{' '}
            <a href="mailto:info@axissoftsolutions.com">
              info@axissoftsolutions.com
            </a>
          </li>
        </ul>
        <br />
        <br />
      </div>

      <FooterFour />
    </React.Fragment>
  )
}

export default PrivacyPolicy
